import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import { ArticleStyle } from '../../../styles'
import { ArticleNav, Gallery, ArrowDrop} from '../../../components'
import { withLoader } from '../../../hoc/withLoader'
import { Date_FR } from './../../../helpers/date'

class Article extends Component {

  render () {
    const { data, isReady } = this.props
    return (
      <div className={`${ArticleStyle} news-article transition ${isReady ? 'transition--ready' : ''}`}>
        {
          data && (
            <div className="flex">
              <ArticleNav is_bookmark={data.is_bookmark} pdf={data.pdf} slug_bookmark={data.slug_bookmark} type={data.type} classname='news-nav' next={data.next} previous={data.previous} />
              <div className="news">
                <div className="news-inner">
                  <div className="news-date"> {Date_FR(data.date)} </div>
                  <div className="news-title"> {data.title} </div>
                  {
                    data.blocks && data.blocks.length > 0 && data.blocks.map((bloc, index) => (
                      <div className="news-block" key={index}>
                        {
                          bloc.type === 'text' && <div className="news-content content" dangerouslySetInnerHTML={{__html: bloc.fields.text}} /> 
                        }
                        {
                          bloc.type === 'image' && ( 
                            <div className="news-cover">
                              <div className="news-picture" style={{backgroundImage: `url(${bloc.fields.image})`}}></div>
                              <div className="news-legend"> {bloc.fields.legend} </div>
                            </div>
                          )
                        }
                        {
                          bloc.type === 'gallery' && bloc.fields.images.length > 0 && (
                            <Gallery images={bloc.fields.images}></Gallery>
                          )
                        }
                      </div> 
                    ))
                  }
                  { (data.next || data.previous) && (
                      <div className="flex news__nav">
                        {
                          data.previous && (
                            <div className="news__previous news__nav-item">
                              <Link to={data.previous} className="btn btn--next">
                                <span className="btn--arrow">
                                  <ArrowDrop width={24} height={24} />
                                </span>
                                <span>Previous</span>
                              </Link>
                            </div>
                          )
                        }
                        {
                          data.next && (
                            <div className={`news__next news__nav-item ${!data.previous ? 'news__nav-item--full' : ''}`}>
                              <Link to={data.next} className="btn btn--next">
                                <span>Next</span>
                                <span className="btn--arrow">
                                  <ArrowDrop width={24} height={24} />
                                </span>
                              </Link>
                            </div>
                          )
                        }
                      </div>
                  )}
                </div>
              </div>
            </div>
          )
        }
      </div>
    )
  }
}

export default withLoader(Article)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Article.js